var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "listing-layout flex-column hp-10" }, [
    _c("header", { staticClass: "flex-level mb-4" }, [
      _vm.$slots["header"] != "" || _vm.metaTitle != ""
        ? _c(
            "h1",
            { staticClass: "m-0" },
            [
              _vm._t("header", [_vm._v(_vm._s(_vm.metaTitle))]),
              _vm._v(" "),
              _vm.funnelFilter
                ? _c(
                    "CompassSelect",
                    {
                      on: {
                        "update:value": function(value) {
                          return _vm.updateFunnelFilter(value)
                        }
                      },
                      model: {
                        value: _vm.funnelFilter.data.choice,
                        callback: function($$v) {
                          _vm.$set(_vm.funnelFilter.data, "choice", $$v)
                        },
                        expression: "funnelFilter.data.choice"
                      }
                    },
                    _vm._l(_vm.funnelList, function(pipe, index) {
                      return _c("CompassDropdownSelectOption", {
                        key: index,
                        attrs: { value: pipe.value, label: pipe.label }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "fs-3" }, [
                _vm._v(
                  "(" +
                    _vm._s(
                      _vm.$l10n.n__(
                        "%(nb)s opportunité",
                        "%(nb)s opportunités",
                        _vm.totalOpp,
                        {
                          nb: _vm.totalOpp
                        }
                      )
                    ) +
                    ")"
                )
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "flex-right" }, [
        _c(
          "ul",
          { staticClass: "action-nav" },
          [
            _vm._l(_vm.primaryButtons, function(button) {
              return _c(
                "li",
                { key: button.label },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t.__("common.labels.no_necessary_rights"),
                        placement: "top",
                        disabled: !button.disabled
                      }
                    },
                    [
                      button.event != undefined
                        ? _c("CompassButton", {
                            attrs: {
                              label: button.label,
                              disabled: button.disabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit(button.event)
                              }
                            }
                          })
                        : _c("CompassButton", {
                            attrs: {
                              label: button.label,
                              disabled: button.disabled
                            },
                            on: {
                              click: function($event) {
                                return _vm.hrefButton(button.href)
                              }
                            }
                          })
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.secondaryButtons.length > 0
              ? _c(
                  "li",
                  [
                    _c(
                      "el-dropdown",
                      { attrs: { placement: "bottom-end" } },
                      [
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          _vm._l(_vm.secondaryButtons, function(button) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: button.label,
                                attrs: { disabled: button.disabled }
                              },
                              [
                                button.event != undefined
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "black-link block nowrap",
                                        on: {
                                          click: function($event) {
                                            return _vm.$emit(button.event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(button.label) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "a",
                                      {
                                        staticClass: "black-link block nowrap",
                                        attrs: { href: button.href },
                                        on: {
                                          click: function($event) {
                                            button.click != undefined
                                              ? button.click
                                              : ""
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(button.label) +
                                            "\n                                "
                                        )
                                      ]
                                    )
                              ]
                            )
                          }),
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "listing prelative flex-column mh-0 flex" },
      [
        _c(
          "div",
          { staticClass: "listing-tools flex-level flex-top no-shrink mb-2" },
          [
            _c(
              "div",
              { staticClass: "flex flex-level flex-top" },
              [
                _vm.enableFiltering
                  ? _c("CompassButton", {
                      attrs: { label: _vm.$t.__("common.actions.filter") },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.$store.dispatch(
                            _vm.listinghash + "/toggleDisplay",
                            "filters"
                          )
                        }
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.display.filters
                  ? _c("filters-preview", {
                      attrs: { listinghash: _vm.listinghash }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassToggleButtonGroup",
              {
                staticClass: "ml-2",
                attrs: {
                  value: _vm.activeToggleButton,
                  exclusive: "",
                  size: "small"
                }
              },
              _vm._l(_vm.displayModes, function(mode, index) {
                return _c(
                  "CompassTooltip",
                  {
                    key: mode.class,
                    attrs: { content: mode.label, arrow: false }
                  },
                  [
                    _c("CompassToggleButton", {
                      attrs: { value: mode.class, icon: mode.icon },
                      nativeOn: {
                        click: function($event) {
                          return _vm.setDisplayMode(mode.class, index)
                        }
                      }
                    })
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-row mh-0 flex" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.display.filters && _vm.enableFiltering,
                    expression: "display.filters && enableFiltering"
                  }
                ],
                staticClass: "leftpane well well-no-shadow mr-4 flex-column"
              },
              [_c("filters-pane", { attrs: { listinghash: _vm.listinghash } })],
              1
            ),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "slide-fade" } },
              [
                _vm.display.columns
                  ? _c("listing-columns", {
                      attrs: { listinghash: _vm.listinghash }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "slide-fade" } },
              [
                _vm.display.table
                  ? _c("listing-display", {
                      attrs: {
                        listinghash: _vm.listinghash,
                        "show-display-mode": true,
                        "show-display-pagination": false
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "listingContainer flex flex-column" }, [
              _c(
                "div",
                { staticClass: "listingContent prelative ov-auto" },
                [
                  !_vm.error &&
                  !_vm.loading &&
                  Object.keys(_vm.rows).length == 0
                    ? _c(
                        "div",
                        { staticClass: "placeholder" },
                        [
                          _c("p", { staticClass: "acenter" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Aucun résultat ne correspond aux filtres appliqués"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("CompassButton", {
                            attrs: { label: _vm.$t.__("common.actions.reset") },
                            on: {
                              click: function($event) {
                                return _vm.$store.dispatch(
                                  _vm.listinghash + "/resetListing"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("pipeline", { attrs: { listinghash: _vm.listinghash } })
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _vm.display.favoritesForm
          ? _c("listing-favoritesform", {
              attrs: {
                listinghash: _vm.listinghash,
                "favorite-data": _vm.favoriteData,
                "has-layout": false
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.display.export
          ? _c("export-modal", {
              attrs: {
                listinghash: _vm.listinghash,
                "export-type": _vm.display.exportType
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }